import { adminHttpClient } from '../../../commons/adminHttpClient'

type SaveSeatsRequest = {
  planPeriodId: string
  seatNumber: number
}

const saveSeats = (seat: SaveSeatsRequest): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/Seat', seat)
}

export default saveSeats
